function CopyController(){
	this.className			= "CopyController";
	this.view				= false; //"example";
	this.glob				= ["/copy/"];
	this.viewData			= {};
}
CopyController.inheritsFrom( PageController );

CopyController.prototype.on = function(onComplete){
	this.$body				= $('body');


	var urls = [];

	/* DONE THIS NOW, SAVE IT*/
	/*
	var index = "https://sppropertygroup.com/market-commentary/";
	$.ajax({url: index}).then(e => {

		var matches = e.match(/<body.*?>([\s\S]*?)<\/body>/);
		var $e = $(matches[1]);
		$e.find("h3.elementor-post__title a").each(function(){
			var href = $(this).attr("href")

			var pre = "https://sp";
			if(href.substr(0,pre.length) !== pre) return;

			const parts = href.split(".com");
			const uri = parts[1];
			const uriParts = uri.split("/");
			if(uriParts.length !== 3) return false;

			urls.push(href);


		})

		/*console.log(urls);
		$.ajax({
			url: "/save/",
			method: "json",
			data: JSON.stringify({
				name: "urls",
				data: urls
			})
		})*/

	$.ajax({url: "/assets/save/urls.json", contentType:"json"}).then(urls => {


		this.conversions = [];
		this.articles = [];
		var promises = [];


		var c = 0;
		urls.forEach(url => {
			//if(c++ > 1) return;

			var promise = this.copyUrl(url);
			if(promise) promises.push(promise);

		})



		this.when(...promises).then(() => {
			console.log("Loaded articles")
			console.log(this.articles)

			var simple = [];
			this.articles.forEach(article => {
				simple.push({name: article.name, title: article.title});
			});
			$.ajax({
				url: "/save/",
				method: "json",
				data: JSON.stringify({
					name: "titles",
					data: simple
				})
			})

			//Extra chnges
			// <p>By Jo Eccles</p>
			// sppropertygroup.com > eccord
			// SP Property Group > Eccord
			// SP > Eccord
			// info@eccord.com > enquire@eccord.com

			$.ajax({
				url: "/save/",
				method: "json",
				data: JSON.stringify({
					name: "conversions",
					data: this.conversions
				})
			})

			this.articles.forEach(article => {
				$.ajax({
					url: "/save/",
					method: "json",
					data: JSON.stringify({
						name: "article",
						file: article.name,
						data: article.content
					})
				})
			})

		});



})


	return true;
}
CopyController.prototype.when = function(...promises){
	var results = [];
	var fails = [];
	var complete = 0;
	var dfd = jQuery.Deferred();

	promises.forEach( (promise, i) => {
		var c = e => {
		complete++;
	if(complete == promises.length) dfd.resolve(...results);
	}
	var s = e => {
		results[i] = e;
		c();
	}
	var f = e => {
		results[i] = null;
		fails[i] = e;
		c();
	}
	promise.then(s,f);
	});

	if(!promises.length) dfd.resolve([]);

	return dfd.promise();
}
CopyController.prototype.saveImage = function(from,to) {
	this.images = this.images ? this.images+1 : 1;


	setTimeout(() => {
		$.ajax({
			url: "/save/",
			method: "json",
			data: JSON.stringify({
				name: "image",
				from: from,
				to: to
			})
		})
	}, this.images * 500);

}
CopyController.prototype.copyUrl = function(url) {
	const parts = url.split(".com");
		const uri = parts[1];
		const uriParts = uri.split("/");


		if(uriParts.length !== 3) return false;

		const name = uriParts[1];



		return $.ajax({url: url}).then(e => {

			var matches = e.match(/<body.*?>([\s\S]*?)<\/body>/);
			var $e = $(matches[1]);

			var title = $e.find("h1.elementor-heading-title").text();
			if(!title) return false;

			$e.find("h1.elementor-heading-title").remove();

			//console.log("found: " + title)

			var articles = this.articles;
			var toIgnore = ["https://sppropertygroup.com/wp-content/uploads/2018/11/property-ombudsman-bw.jpg",
			"https://sppropertygroup.com/wp-content/uploads/2018/10/property-ombudsman-residental-leasehold.jpg",
			"https://sppropertygroup.com/wp-content/uploads/2018/11/arla-propertymark-bw.jpg",
			"https://sppropertygroup.com/wp-content/uploads/2018/11/arp-bw.jpg",
			"https://sppropertygroup.com/wp-content/uploads/2018/10/Screen-Shot-2020-06-03-at-20.47.13-530x750.png",
			"https://sppropertygroup.com/wp-content/uploads/2018/10/Screen-Shot-2020-06-03-at-20.47.01-530x750.png"];


			var html = "";
			var sections = $e.find(".elementor-section-wrap > section");
			sections.each(function(){
				var $section = $(this);
				var cols = $section.find(".elementor-text-editor, .elementor-image");
				cols.each(function(){



					var thisHtml = $(this).html();
					console.log(thisHtml)

					var ignore = false;
					for(var i = 0; i < toIgnore.length; i++){
						if(thisHtml.indexOf(toIgnore[i]) > 0) ignore = true;
					}

					var toCheck = `<span style="color: #7a7a7a;`;
					if(!ignore && thisHtml.substr(0,toCheck.length) !== toCheck){
						html += thisHtml + "\n";
					}


				})
			})

	//console.log(html)




			var _this = this;
			if(html && html.length > 400){ //Lets assume this is enough to be a read article


				var imageCount = 0;
				var $html = $("<div>").append(html);





				$html.find("img").each(function(){
					var $img = $(this);
					var src = $img.attr("src");

					if(toIgnore.includes(src)){
						$img.addClass("remove");
						return;
					}

					var exts = src.split(".");
					var ext = exts[exts.length-1];
					var newSrc = "assets/images/uploads/insights/"+name+"-"+(++imageCount)+"."+ext;
					$img.attr("src","/" + newSrc);
					$img.attr("srcset",null)
					$img.attr("sizes",null)
					$img.attr("loading",null)
					$img.attr("class",null)
					_this.saveImage(src,newSrc);
					_this.conversions.push({from:src,to:newSrc});
				})
				//$html.find(".remove").remove();
				html = $html.html();

				articles.push({
					name: name,
					title: title,
					content: html
				});
			}



		});



}

